import React, { lazy } from 'react';
import { Sparkles, Ruler, Weight, CheckCircle2, ArrowRight } from 'lucide-react';
export function EysProductThree() {
  return <section className="w-full bg-white" data-id="element-150">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16" data-id="element-151">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center" data-id="element-152">
          {/* Image side */}
          <div className="relative order-2 lg:order-1" data-id="element-153">
            <div className="bg-marine-light rounded-2xl p-6 border border-marine-blue/20" data-id="element-154">
              <img src="//drwzpk38qkpfb.cloudfront.net/www.clrmarine.com/preview/uploaded/images/EXTEND_YOUR_STEP/EYS-2c.jpg?opt=w3" alt="Extend Your Step on Boarding Ladder swinging down" title="Extend Your Step on Boarding Ladder swinging down" loading="lazy" className="w-full rounded-xl object-cover aspect-[4/3] shadow-lg" data-id="element-155" />
            </div>
            <div className="absolute -top-3 -left-3 bg-marine-cyan text-marine-navy text-xs font-bold uppercase tracking-wider px-3 py-1.5 rounded-full shadow-md flex items-center gap-1.5" data-id="element-156">
              <Sparkles className="w-3.5 h-3.5" data-id="element-157" />
              All New
            </div>
          </div>

          {/* Content side */}
          <div className="order-1 lg:order-2" data-id="element-158">
            <div className="inline-flex items-center gap-2 text-marine-blue text-xs font-semibold uppercase tracking-wider mb-3" data-id="element-159">
              <Sparkles className="w-4 h-4" data-id="element-160" />
              Now Available
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-marine-navy mb-3" data-id="element-161">
              Extend Your Step Three
            </h2>
            <p className="text-slate-700 leading-relaxed mb-4" data-id="element-162">
              You asked for it — a <strong data-id="element-163">longer, non-moving</strong> version
              of Extend Your Step. When attached to the second step of your
              boarding ladder, Extend Your Step Three won&rsquo;t swing while
              giving you a convenient ladder extension.
            </p>
            <p className="text-slate-700 leading-relaxed mb-5" data-id="element-164">
              Prefer it to swing? Attach it to your bottom rung and{' '}
              <strong data-id="element-165">Extend Your Step 3</strong> will give you three additional
              steps — making it easier than ever to get on and off your boat in
              any circumstance. It can even be used as a boarding ladder for
              your dinghy.
            </p>

            <div className="grid grid-cols-2 gap-4 mb-5" data-id="element-166">
              <div className="bg-slate-50 border border-slate-200 rounded-lg p-4" data-id="element-167">
                <div className="flex items-center gap-2 text-marine-blue text-xs font-semibold uppercase tracking-wider mb-1" data-id="element-168">
                  <Ruler className="w-4 h-4" data-id="element-169" />
                  Dimensions
                </div>
                <div className="text-marine-navy font-bold text-lg" data-id="element-170">
                  10" × 41"
                </div>
                <div className="text-xs text-slate-600" data-id="element-171">Wide × Long</div>
              </div>
              <div className="bg-slate-50 border border-slate-200 rounded-lg p-4" data-id="element-172">
                <div className="flex items-center gap-2 text-marine-blue text-xs font-semibold uppercase tracking-wider mb-1" data-id="element-173">
                  <Weight className="w-4 h-4" data-id="element-174" />
                  Weight Limit
                </div>
                <div className="text-marine-navy font-bold text-lg" data-id="element-175">
                  230 lbs
                </div>
                <div className="text-xs text-slate-600" data-id="element-176">Recommended max</div>
              </div>
            </div>

            <ul className="space-y-2.5 mb-6" data-id="element-177">
              <li className="flex items-start gap-2.5" data-id="element-178">
                <CheckCircle2 className="w-5 h-5 text-marine-cyan flex-shrink-0 mt-0.5" data-id="element-179" />
                <span className="text-sm text-slate-700" data-id="element-180">
                  Fits any tubular boarding ladder and flat steps up to{' '}
                  <strong data-id="element-181">1.25"</strong> — flat, square, or round.
                </span>
              </li>
              <li className="flex items-start gap-2.5" data-id="element-182">
                <CheckCircle2 className="w-5 h-5 text-marine-cyan flex-shrink-0 mt-0.5" data-id="element-183" />
                <span className="text-sm text-slate-700" data-id="element-184">
                  Same durability and compatibility as the original, with{' '}
                  <strong data-id="element-185">3 additional steps</strong>.
                </span>
              </li>
              <li className="flex items-start gap-2.5" data-id="element-186">
                <CheckCircle2 className="w-5 h-5 text-marine-cyan flex-shrink-0 mt-0.5" data-id="element-187" />
                <span className="text-sm text-slate-700" data-id="element-188">
                  Can even be used as a boarding ladder for your dinghy.
                </span>
              </li>
            </ul>

            <a href="https://www.clrmarine.com/m4/0CLR_3--40‑inch‑marine‑boarding‑ladder‑extension‑0clr-3.html" className="inline-flex items-center justify-center gap-2 bg-marine-cyan hover:bg-cyan-400 text-marine-navy font-semibold px-5 py-3 rounded-lg transition-colors duration-200" data-id="element-189">
              Purchase Extend Your Step Three
              <ArrowRight className="w-4 h-4" data-id="element-190" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}